import PropTypes from 'prop-types';

const sizes = {
  small: {
    width: '12',
    height: '11'
  },
  normal: {
    width: '20',
    height: '20'
  }
};

const PlusIcon = ({ color = '#0D0D0D', size = 'small', className = '' }) => {
  const { width, height } = sizes[size] || sizes.normal;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.90963 2.91455C7.90963 4.2238 6.84827 5.28516 5.53901 5.28516C4.22976 5.28516 3.1684 4.2238 3.1684 2.91455C3.1684 1.6053 4.22976 0.543945 5.53901 0.543945C6.84827 0.543945 7.90963 1.6053 7.90963 2.91455ZM11.0702 8.12912C11.0702 9.43837 10.0089 10.4997 8.69963 10.4997C7.39038 10.4997 6.32902 9.43837 6.32902 8.12912C6.32902 6.81987 7.39038 5.75852 8.69963 5.75852C10.0089 5.75852 11.0702 6.81987 11.0702 8.12912ZM2.38429 10.499C3.69354 10.499 4.7549 9.43764 4.7549 8.12839C4.7549 6.81914 3.69354 5.75778 2.38429 5.75778C1.07503 5.75778 0.0136719 6.81914 0.0136719 8.12839C0.0136719 9.43764 1.07503 10.499 2.38429 10.499Z"
        fill={color}
      />
    </svg>
  );
};

PlusIcon.propTypes = {
  size: PropTypes.oneOf(Object.keys(sizes)),
  color: PropTypes.string,
  className: PropTypes.string
};

export default PlusIcon;
